<section class="page">

    <div class="extra-padding">

        <header>
            <h1>Page Not Found</h1>
        </header>
    
        <div class="content">
            <h3>Sorry, we can't find the page you're looking for.</h3>
            <p>Please check the URL you were trying to reach, return to the homepage or if you need further assistance you can contact support.</p>
        </div>
    
        <div class="button-container">
    
            <a kendoButton 
                class="k-button default orange"
                routerLink="/" 
                size="large" 
                rounded="full">Go To Home Page</a>
            
            <a kendoButton 
                class="k-button default orange"
                routerLink="/faq/support" 
                size="large" 
                rounded="full">Go To Support</a>
    
        </div>

    </div>



</section>

